import { render } from "./ArchiveList.vue?vue&type=template&id=183a8daa&scoped=true"
import script from "./ArchiveList.vue?vue&type=script&lang=js"
export * from "./ArchiveList.vue?vue&type=script&lang=js"

import "./ArchiveList.vue?vue&type=style&index=0&id=183a8daa&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183a8daa"]])

export default __exports__